module.exports = __webpack_public_path__ + "static/img/15.4d7ee6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/zh/15.png
// module id = 4HvJ
// module chunks = 0